import React, { FC } from 'react';
import { Icon, Tooltip } from '@silverfort/sf-components';
import { getRiskIndicatorByRiskRule } from '@silverfort-nodelibs/common/utils/insight';
import { getRiskIcon } from '../../../../consts/Insight';
import { useIspmContext } from '../../IspmContext';

interface Props {
    risk_indicators: string[];
}

const MAX_NUMBER_OF_ICONS = 2;

const getRiskIndicatorName = (riskId: string, customInsightsIdsToNames: Record<string, string>): string | null => {
    return getRiskIndicatorByRiskRule(riskId)?.entityTitle ?? customInsightsIdsToNames?.[riskId] ?? null;
};

const RiskIndicatorsColumn: FC<Props> = ({ risk_indicators = [] }) => {
    const { customInsightsIdsToNames } = useIspmContext();
    const maxDisplayedRisks = MAX_NUMBER_OF_ICONS;
    const notDisplayedRisksCount = (risk_indicators?.length ?? 0) - maxDisplayedRisks;
    // If we don't have UI name for the risk, we don't need to show it.
    const uiRiskIndicators = risk_indicators.filter(ri => !!getRiskIndicatorName(ri, customInsightsIdsToNames));
    const notDisplayedRisksDescriptions = uiRiskIndicators
        ? uiRiskIndicators?.slice(maxDisplayedRisks).map((insight) => (
              <span key={insight} className="w-full">
                  {getRiskIndicatorName(insight, customInsightsIdsToNames)}
              </span>
          ))
        : [];

    return (
        <div className="h-full w-full flex items-center gap-2">
            {uiRiskIndicators &&
                uiRiskIndicators.slice(0, maxDisplayedRisks).map((insight) => {
                    const insightIcon = getRiskIcon(insight);
                    const insightTitle = getRiskIndicatorName(insight, customInsightsIdsToNames);

                    return (
                        <div className="w-6 h-6 border rounded flex items-center justify-center" key={insightTitle}>
                            <Tooltip className="w-full h-full flex items-center justify-center" title={insightTitle}>
                                <Icon icon={insightIcon} className="text-sf-gray-400" size={16} />
                            </Tooltip>
                        </div>
                    );
                })}
            {notDisplayedRisksDescriptions.length > 0 && (
                <div className="h-6 px-2 rounded flex items-center justify-center border">
                    <Tooltip
                        className="w-full h-full flex items-center justify-center"
                        title={<div className="flex flex-col">{notDisplayedRisksDescriptions}</div>}>
                        <span className="text-12 font-sf">{`+${notDisplayedRisksCount}`}</span>
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export default RiskIndicatorsColumn;
